<template>
  <button
    :slot="customSlot"
    :type="type"
    :class="[customClass, `btn-direction--${direction}`]"
    class="btn-direction"
    @click="handleClick"
  >
    <Icon :icon="icon" />
  </button>
</template>

<script>
export default {
  name: "AccordionButton",
  components: {
    Icon: () => import("../elements/Icon"),
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    propsHandleClick: {
      type: Function,
      default: null,
    },
    direction: {
      type: String,
      default: "next", // prev (prev-down), next (prev-down), prev-up, next-up
    },
    customClass: {
      type: String,
      default: null,
    },
    customSlot: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick(value) {
      if (this.propsHandleClick) this.propsHandleClick(value);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.filter {
  &__reset {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 0;
  }

  &-reset {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    border: none;
    color: $red;
    font-size: 1.4rem;

    &:hover {
      text-decoration: underline;
    }
  }
}
.btn-direction {
  border: 0;
  background-color: $white;
  width: 3.5rem;
  height: 2.5rem;

  &--prev,
  &--prev-down {
    &::before {
      content: none;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      display: none;
      width: 1.2rem;
      height: 1.2rem;
      margin: -0.6rem 0 0 -0.6rem;
      background: url("../../assets/icons/i_arrow-red.svg") no-repeat center;
      background-size: contain;
      transition: 0.3s ease-out;
    }
    .icon {
      transform: translate(-75%, -50%);
    }
  }

  &--prev-up {
    &::before {
      content: none;
    }

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      display: none;
      width: 1.2rem;
      height: 1.2rem;
      margin: -0.6rem 0 0 -0.6rem;
      background: url("../../assets/icons/i_arrow-red.svg") no-repeat center;
      background-size: contain;
      transition: 0.3s ease-out;
    }
    .icon {
      transform: translate(-75%, -50%);
    }
  }

  &--next,
  &--next-down {
    .icon {
      transform: translate(-25%, -50%);
    }
  }

  &--next-up {
    .icon {
      transform: translate(-25%, -50%);
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &.swiper-button-disabled,
  &.disabled,
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .icon {
    position: absolute;
    left: 50%;
    top: 50%;
  }
}
</style>
